const CelebrationBadge = ({ children }) => {
  return (
    <span className="inline-flex items-center rounded-full bg-white/80 px-4 py-1 text-sm font-semibold text-purple-700 shadow-sm ring-1 ring-white/60 backdrop-blur">
      {children}
    </span>
  );
};

export default CelebrationBadge;
